(function($){
	$(document).ready(()=>{
		$(document).on('submit', '.js-form-preorder', function (event) {
			event.preventDefault();
			var $this = $(this),
				$response = $this.find('.js-response');
			$response.removeClass('__success-message').removeClass('__error-message');
			$.ajax({
				url: $this.attr('action'),
				type: $this.attr('method'),
				data: $this.serializeArray(),
				dataType: 'json',
				success: function (response) {
					if (response.data.success) {
						$response.addClass('__success-message').html(response.data.message).show();
						setTimeout(function () {
							$response.hide();
							$.magnificPopup.close();
						}, 1000);
					} else {
						$response.addClass('__error-message').html(response.data.message).show();
					}
				}
			});
		});

		$(document).on('click', '.js-open-preorder', function (event) {
			event.preventDefault();
			var $this = $(this);
			$.magnificPopup.open({
				items: {
					src: '/api/frontend-component/' +
						'?component=realweb:blank&template=preorder&type=html&params[ID]=' + $this.attr('data-id'),
					type: 'ajax'
				},
				settings: {cache: false, async: false},
				closeBtnInside: true,
				closeMarkup:
					'<button title="%title%" type="button" class="mfp-close modal__close"><i class="icon-close"></i></button>',
				callbacks: {
					ajaxContentAdded: function() {
						initPhoneMask('.js-form-preorder [name="phone"]');
					}
				}
			});
		});
	});
// eslint-disable-next-line no-undef
})(jQuery);
